import { Model, Attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

@Model()
export default class AnonEmail extends ApplicationRecord {
  static jsonapiType = 'anon-emails';

  @Attr() anon: boolean;
  @Attr() emailAddress: string;
}
